module.exports = __webpack_public_path__ + "img/symbol_1.53b7b1c9.png";